import React, { useMemo } from 'react';
import { Card, ListGroup } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import Logo from 'components/common/Logo';
import paths from 'routes/paths';
import { getRelativePath } from 'helpers/utils';
import { useAuthContext } from 'context/authContext';
import {
  permissionsKeyMap,
  userActions
} from 'routes/permissions/permissionKeys';

const CardNav = () => {
  const location = useLocation();
  const { ability } = useAuthContext();

  // Check if user has permission to view donors
  const canViewDonors = ability.can(
    userActions.read,
    permissionsKeyMap.donor.children.donors
  );

  const navLinks = useMemo(() => {
    const links = [
      { id: 1, title: 'Overview', link: paths.beneficiaryProfile },
      { id: 2, title: 'School', link: paths.beneficiaryShool },
      { id: 3, title: 'Madrasah', link: paths.beneficiaryMosque },
      { id: 4, title: 'Orphanage', link: paths.beneficiaryOrphanage },
      { id: 5, title: 'Hospital', link: paths.beneficiaryHospital },
      {
        id: 7,
        title: 'Gallery',
        link: paths.beneficiaryGallery
      },
      {
        id: 8,
        title: 'Notes',
        link: paths.beneficiaryNotes
      },
      {
        id: 9,
        title: 'Supporting Docs',
        link: paths.beneficiarySupportingDocs
      },
      { id: 10, title: 'Case Studies', link: paths.beneficiaryCaseStudies }
    ];

    // Only add Donors link if user has permission
    if (canViewDonors) {
      links.splice(5, 0, {
        id: 6,
        title: 'Donors',
        link: paths.beneficiaryDonors
      });
    }

    return links;
  }, [canViewDonors]);

  return (
    <Card className="mt-3">
      <Card.Body className="p-3">
        <Logo width={20} textClass="h5" />

        <ListGroup activeKey={location.pathname}>
          {navLinks.map(({ id, link, isNotRelative, title }) => (
            <ListGroup.Item
              className="border-0"
              key={id}
              action
              as={Link}
              to={
                isNotRelative ? link : getRelativePath(link, paths.donorDetails)
              }
              active={
                location.pathname ===
                (isNotRelative
                  ? link
                  : getRelativePath(link, paths.donorDetails))
              }
            >
              {title}
            </ListGroup.Item>
          ))}
        </ListGroup>
      </Card.Body>
    </Card>
  );
};

export default CardNav;
